<template>
  <div>
    <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="新建活动(全局)" name="1">
        <global-event-program ref="eventProgram"></global-event-program>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import globalEventProgram from '../dot/order/taskTemplate/global-event-program'
import {statistics} from '@/api/dot/flow'
import {mapGetters, mapState} from "vuex";
export default {
  components: {globalEventProgram},
  data() {
    return {
      activeName: "1",
      staParams: null
    }
  },
  beforeRouteEnter(to, from, next) {
		next(vm=>{
			vm.curPath = to.path;
			vm.oldPath = from.path;
		})
	},
  mounted() {
    this.staParams = {
			u_id: this.userInfo.staffId,
			time: new Date().getTime(),
			browser: navigator.userAgent.toLowerCase(),
			url: document.URL,
			scene_name: '查看活动（全局）'
		}
    this.statistics();
  },
  methods: {
    statistics() {
			statistics(Object.assign({
				event_type: 'view',
				ref_url: this.oldPath,
			}, this.staParams))
		},

    handleClick(tab, event) {
        this.$refs.eventProgram.init();
    },
  },
  computed: {
    ...mapGetters(['permissions']),
    ...mapState({
			userInfo: state => state.user.userInfo
		}),
  },
  filters: {},
}

</script>
<style lang="scss" scoped>
.avue-view {
  background: #FFFFFF;
  padding: 20px;
  min-height: calc(100vh - 100px);
}

.desc-info {
  width: 100%;
  padding-left: 0;

  > span {
    margin-right: 50px;
  }
}
</style>
